// Persistencia de los filtros de la home de Obras POR PESTAÑA (hallazgo QA en
// vivo de Juan, 21/9/2026: al entrar a una obra y volver, la home perdía todo
// — sessionStorage, no la URL). Reescrito para R4a (context/plan_migracion_reui.md,
// «R4a — Home con Filtros»; contrato en components/obras/obras-filtros-tipos.ts):
// ahora guarda el `FiltrosObras` ENTERO (los elegidos, no los destildados) bajo
// la clave `OBRAS_FILTROS_STORAGE_KEY` (v4 del NOMBRE; v2 del CONTRATO,
// `OBRAS_FILTROS_VERSION`, embebida en el JSON). Lo persistido con la v1 a v3
// vieja (shape de destildados) simplemente no matchea `parsearPersistidos` y
// se ignora sin migrar — inocuo, sessionStorage es por pestaña.
//
// `serializar`/`parsearPersistidos` (la lógica de shape y saneamiento) viven
// en components/obras/obras-filtros.ts: este hook solo orquesta la lectura y
// escritura de sessionStorage, con el mismo blindaje defensivo de siempre
// (modo privado, storage lleno/bloqueado, JSON corrupto → no rompe la home).
import { parsearPersistidos, serializar } from '@/components/obras/obras-filtros';
import { OBRAS_FILTROS_STORAGE_KEY, type FiltrosObras } from '@/components/obras/obras-filtros-tipos';

export function leerFiltrosPersistidos(): FiltrosObras | null {
  try {
    return parsearPersistidos(sessionStorage.getItem(OBRAS_FILTROS_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function guardarFiltrosPersistidos(filtros: FiltrosObras): void {
  try {
    sessionStorage.setItem(OBRAS_FILTROS_STORAGE_KEY, serializar(filtros));
  } catch {
    // Modo privado o storage lleno/bloqueado: no persiste, pero la home
    // sigue funcionando igual (arranca de cero la próxima vez).
  }
}

export function borrarFiltrosPersistidos(): void {
  try {
    sessionStorage.removeItem(OBRAS_FILTROS_STORAGE_KEY);
  } catch {
    // idem arriba.
  }
}
